export const SET_VIRTUAL_CARD_OFFER = 'virtual-card/SET_VIRTUAL_CARD_OFFER';
export const SET_SELECTED_CARD_INFO = 'setting/SET_SELECTED_CARD_INFO';
export const SET_SELECTED_CARD_TRANSACTIONS = 'setting/SET_SELECTED_CARD_TRANSACTIONS';
export const SET_SELECTED_TRANSACTION = 'setting/SET_SELECTED_TRANSACTION';
export const SET_VIRTUAL_CARDS_LIST = 'virtual-card/SET_VIRTUAL_CARDS_LIST';
export const SET_VIRTUAL_CARDS_ITEM_OPTIMISTIC_UPDATE = 'virtual-card/SET_VIRTUAL_CARDS_ITEM_OPTIMISTIC_UPDATE';
